import { createFileRoute } from "@tanstack/react-router";

import PendingPayment from "./-components/PendingPayment";

export const Route = createFileRoute(
  "/_app/_dashboard/subscription/pending/$paymentid"
)({
  component: PendingPayment,
});
